export const TOKEN_EXPIRED = 'token_expired';
export const OPEN_FAVORITE_CLAIM = 'open_favorite_claim';
export const OPEN_MENU = 'open_menu';
export const OPEN_ALERT = 'open_alert';

export default {
  TOKEN_EXPIRED,
  OPEN_FAVORITE_CLAIM,
  OPEN_MENU,
  OPEN_ALERT
};
